import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import cn from '@/helpers/cn';
import css from './style.module.scss';
interface Props {
  isMinus: boolean;
}
const PlusMinusIcon: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    isMinus: t1
  } = t0;
  const isMinus = t1 === undefined ? false : t1;
  const t2 = isMinus ? css.minus : "";
  let t3;
  if ($[0] !== t2) {
    t3 = cn(css.icon, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g className={css.verticalLine}><rect x="185" width="15" height="400" /></g>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <g className={css.horizontalLine}><rect y="185" width="400" height="15" /></g>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3) {
    t6 = <svg className={t3} viewBox="0 0 400 400" fill="currentColor">{t4}{t5}</svg>;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default PlusMinusIcon;